import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import SubMenu from './subMenu';
import ArrowIcon from './icons/arrow.svg';
import Hambugger from './icons/hambugger.svg';
import compose from 'lodash/fp/compose';
import { SidebarData, AdminSidebarData } from './SidebarData';
import { withTranslation, withAccount, withAdminRouteFiltering } from '../../hoc';
import { Link } from 'react-router-dom';
import { useDarkMode } from 'context/DarkModeContext';

const Wrapper = styled.div`
  position: fixed;
  height: 100vh;
  z-index: 500;

  @media (max-width: 768px) {
    z-index: 10001;
  }
`;

const MobileOverlay = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: ${({ sidebar }) => (sidebar ? 'block' : 'none')};
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    transition: opacity 300ms;
  }
`;

const Container = styled.div`
  background: var(--admincat-color-grey-1);
  width: ${({ sidebar }) => (sidebar ? '280px' : '80px')};
  height: 89vh;
  position: fixed;
  transition: 300ms;
  box-shadow: ${({ sidebar }) =>
    sidebar ? '0 0 10px rgba(0, 0, 0, 0.03)' : 'none'};
  left: 0;
  bottom: 0;

  @media (max-width: 768px) {
    width: 280px;
    height: 100vh;
    top: 0;
    bottom: unset;
    left: ${({ sidebar }) => (sidebar ? '0' : '-280px')};
    box-shadow: ${({ sidebar }) =>
      sidebar ? '2px 0 12px rgba(0, 0, 0, 0.2)' : 'none'};
    z-index: 10000;
    overflow-y: auto;
  }
`;

const UlDiv = styled.ul`
  list-stlye: none;
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;

  @media (max-width: 768px) {
    padding-top: 60px;
  }
`;

const ListDiv = styled.li`
  display: block;
  position: relative;
  padding: 10px;
  background: var(--admincat-color-grey-1);
  margin-bottom: 2px;
  transition: 300ms;
  margin-left: 20px;

  a {
    display: flex;
    align-items: center;
    color: var(--admincat-color-grey-3);
    text-decoration: none;
  }

  &:hover > ul {
    visibility: visible;
    opacity: 1;
  }

  &:hover {
    cursor: pointer;
    background: var(--admincat-color-grey-0);
  }

  .icon {
    margin-right: 10px;
    flex-shrink: 0;
  }
  .title {
    position: absolute;
    left: 40px;
    color: var(--admincat-color-grey-3);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .title.active {
    left: -200px;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    padding: 15px 20px;

    .title {
      position: static;
      left: auto;
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
      max-width: none;
      font-size: 14px;
      line-height: 1.4;
      word-wrap: break-word;
      padding-right: 30px;
    }
    .title.active {
      position: static;
      left: auto;
    }
  }
`;

const ArrowDiv = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);

  @media (max-width: 768px) {
    right: 15px;
    transform: ${({ $isOpen }) => 
      $isOpen ? 'translateY(-50%) rotate(90deg)' : 'translateY(-50%)'};
    transition: transform 300ms ease;
  }
`;

const ToggleDiv = styled.div`
  cursor: pointer;
  position: fixed;
  top: 25px;
  left: 25px;
  z-index: 10000;

  @media (max-width: 768px) {
    top: 15px;
    left: 15px;
    z-index: 10002;
    background: var(--admincat-color-grey-1);
    padding: 8px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
`;

const CloseButton = styled.button`
  display: none;

  @media (max-width: 768px) {
    display: ${({ sidebar }) => (sidebar ? 'block' : 'none')};
    position: absolute;
    top: 15px;
    right: 15px;
    background: transparent;
    border: none;
    font-size: 24px;
    color: var(--admincat-color-grey-3);
    cursor: pointer;
    z-index: 10001;
    padding: 5px 10px;

    &:hover {
      color: var(--admincat-color-grey-4);
    }
  }
`;

const SideBar = (props) => {
  const [sidebar, setSidebar] = useState(false);
  const [openMenus, setOpenMenus] = useState({});
  const { tr, isUserAdmin, isLoggedinAsAdmin } = props;

  const toggleSidebar = () => {
    setSidebar(!sidebar);
  };

  const closeSidebar = () => {
    setSidebar(false);
    setOpenMenus({});
  };

  const toggleMenu = (index, e) => {
    if (window.innerWidth <= 768) {
      e.preventDefault();
      e.stopPropagation();
      setOpenMenus(prev => ({
        ...prev,
        [index]: !prev[index]
      }));
    }
  };

  // Close sidebar on window resize to desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setSidebar(false);
        setOpenMenus({});
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const { isDarkMode } = useDarkMode();

  let filteredSidebarData;
  if (isLoggedinAsAdmin) {
    filteredSidebarData = props.filterAdminRoutes(AdminSidebarData);
  } else {
    filteredSidebarData = isUserAdmin
      ? SidebarData
      : SidebarData.filter((item) => !item.isAdminOnly);
  }

  return (
    <>
      <MobileOverlay sidebar={sidebar} onClick={closeSidebar} />
      <ToggleDiv onClick={toggleSidebar}>
        <img src={Hambugger} alt="Toggle Sidebar" />
      </ToggleDiv>
      <Wrapper>
        <Container sidebar={sidebar}>
          <CloseButton sidebar={sidebar} onClick={closeSidebar}>
            ×
          </CloseButton>
          <UlDiv>
            {filteredSidebarData.map((item, index) => (
              <ListDiv key={index}>
                {item.subNav ? (
                  <div onClick={(e) => toggleMenu(index, e)}>
                    <Link to={item.path} onClick={(e) => {
                      if (window.innerWidth <= 768) {
                        e.preventDefault();
                      } else {
                        closeSidebar();
                      }
                    }}>
                      <div className="icon">
                        <img
                          src={isDarkMode ? item.iconDark : item.icon}
                          alt={item.title}
                        />
                      </div>
                      <div className={sidebar ? 'title' : 'title active'}>
                        {tr(item.title)}
                      </div>
                    </Link>
                    <ArrowDiv $isOpen={openMenus[index]}>
                      <img src={ArrowIcon} alt="Expand" />
                    </ArrowDiv>
                  </div>
                ) : (
                  <Link to={item.path} onClick={closeSidebar}>
                    <div className="icon">
                      <img
                        src={isDarkMode ? item.iconDark : item.icon}
                        alt={item.title}
                      />
                    </div>
                    <div className={sidebar ? 'title' : 'title active'}>
                      {tr(item.title)}
                    </div>
                  </Link>
                )}
                
                {item.subNav && (
                  <SubMenu
                    background={sidebar}
                    setWidth={sidebar}
                    sidebar={sidebar}
                    right={sidebar}
                    items={item.subNav}
                    tr={tr}
                    closeSidebar={closeSidebar}
                    $isOpen={openMenus[index]}
                  />
                )}
              </ListDiv>
            ))}
          </UlDiv>
        </Container>
      </Wrapper>
    </>
  );
};

export default compose(
  withTranslation,
  withAccount,
  withAdminRouteFiltering,
)(SideBar);
